import React from 'react'
import { useForm } from '@inertiajs/react'
import { Box, Paper, Typography, TextField, Button, Stack } from '@mui/material'

interface Props {
  token: string
  errors?: Record<string, string[]>
}

function ResetPassword({ token, errors: serverErrors = {} }: Props) {
  const { data, setData, put, processing } = useForm({
    user: {
      reset_password_token: token,
      password: '',
      password_confirmation: '',
    },
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    put('/users/password')
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 120px)', p: 2 }}>
      <Paper sx={{ p: 4, maxWidth: 420, width: '100%' }}>
        <Typography variant="h4" sx={{ mb: 3, textAlign: 'center' }}>Set new password</Typography>

        <form onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField
              label="New password"
              type="password"
              value={data.user.password}
              onChange={(e) => setData('user', { ...data.user, password: e.target.value })}
              error={Boolean(serverErrors.password)}
              helperText={serverErrors.password?.join(', ') || 'At least 6 characters'}
              required
              fullWidth
            />
            <TextField
              label="Confirm new password"
              type="password"
              value={data.user.password_confirmation}
              onChange={(e) => setData('user', { ...data.user, password_confirmation: e.target.value })}
              error={Boolean(serverErrors.password_confirmation)}
              helperText={serverErrors.password_confirmation?.join(', ')}
              required
              fullWidth
            />
            <Button type="submit" variant="contained" size="large" disabled={processing}>
              Update password
            </Button>
          </Stack>
        </form>
      </Paper>
    </Box>
  )
}

;(ResetPassword as React.ComponentType & { noLayout?: boolean }).noLayout = true

export default ResetPassword
